import { RecycleManager, RuntimeEngine } from '@easytwin/runtime';
import { useBindSignal } from './useBindSignal';
import { useDumbState } from './useDumbState';
import { useMainScene } from './useMainScene';

export const useGetRecycledEntities = (engine: RuntimeEngine | undefined) => {
  const refresh = useDumbState();
  const scene = useMainScene(engine);
  const recycleManager = scene?.getManager(RecycleManager);
  useBindSignal(recycleManager?.signals.updated, refresh);
  return recycleManager?.recycledEntities;
};
